import { render } from "./404.vue?vue&type=template&id=20788452"
const script = {}
script.render = render

export default script